import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';

interface ErrorRouteProps {
    message?: string;
}

const ErrorRoute: React.FC<ErrorRouteProps> = ({ message }) => {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
            <h1 className="text-2xl font-bold mb-4">Uh Oh! You've lost the track! </h1>
            <p className="text-gray-600 mb-6">{message}</p>
            <Button
                onClick={() => navigate('/')}
                className="bg-blue-400 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded"
            >
                Go Home
            </Button>
        </div>
    );
};

export default ErrorRoute;